import React from "react";
import "./assetDetails.css";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import building from "../../Common/buildings.json";
import NavBar from "../../Layout/NavBar/NavBar";
import { GoLocation } from "react-icons/go";
const AssetDetails = (props) => {
  const t = props.language;

  const { assetName } = useParams();
  const openMenu = props.openMenu;
  const onOpen = props.onOpen;

  const assets = building.building;
  const asset = assets.find((asset) => {
    return asset.name === assetName.toUpperCase();
  });
  return (
    <div className="details_wrap">
      <NavBar
        language={props.language}
        languages={props.languages}
        openMenu={openMenu}
        onOpen={onOpen}
        black={true}
      />
      {!openMenu ? (
        <>
          <div className="filler"></div>

          {asset ? (
            <div className="details-asset">
              <div className="asset-details--left">
                <div className="nl">
                  <h3 className="name-asset">{asset ? asset.name : ""}</h3>
                  <h4 className="location-asset">
                    <GoLocation className="location-logo" />
                    {asset ? asset.location : ""}
                  </h4>
                </div>
                <p className="description-asset">
                  {t(`building_${asset.index}`)}
                </p>
                <div className="filler-line"></div>
                <div className="information-asset">
                  {/* <div className="acquisation-asset">
          <h4 className="small-title">Acquisition Year</h4>
          <span className="span-info"></span>
        </div> */}
                  <div className="small-wrap">
                    <div className="asset--div">
                      <h4 className="small-title">{t("la")}</h4>
                      <span className="span-info">
                        {
                          asset[
                            `${t("la").replace(/\s/g, "").replace("'", "")}`
                          ]
                        }
                      </span>
                    </div>
                    <div className="asset--div">
                      <h4 className="small-title">{t("adr")}</h4>
                      <span className="span-info">{asset.adress}</span>
                    </div>
                  </div>
                  <div className="small-wrap">
                    <div className="asset--div">
                      <h4 className="small-title">{t("ad")}</h4>
                      <span className="span-info">
                        {
                          asset[
                            `${t("ad").replace(/\s/g, "").replace("'", "")}`
                          ]
                        }
                      </span>
                    </div>
                    <div className="asset--div">
                      <h4 className="small-title">{t("at")}</h4>
                      <span className="span-info">
                        {
                          asset[
                            `${t("at").replace(/\s/g, "").replace("'", "")}`
                          ]
                        }
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="asset-details--right">
                <img
                  src={require(`../../Assets/Buildings/${asset.name}1.jpg`)}
                  alt=""
                  className="img-asset"
                />
                <div className="img-down">
                  <img
                    src={require(`../../Assets/Buildings/${asset.name}2.jpg`)}
                    alt=""
                    className="img-asset"
                  />
                  {asset.nbImg === "2" ? (
                    <></>
                  ) : (
                    <img
                      src={require(`../../Assets/Buildings/${asset.name}3.jpg`)}
                      alt=""
                      className="img-asset"
                    />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div></div>
          )}
        </>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default AssetDetails;
